var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatchTrianglePhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 618,
    viewBox: "0 0 338 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1858_1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 30.0031C0 13.4329 13.4315 0 30 0H308C324.569 0 338 13.4329 338 30.0031V565.059C338 581.63 324.569 595.062 308 595.062H169H30C13.4315 595.062 0 581.63 0 565.059V30.0031Z",
    fill: "url(#paint0_linear_1858_1051)",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.196 595.062L175.119 613.956C174.745 614.496 174.328 615.008 173.852 615.46C170.281 618.851 168.322 618.846 164.759 615.449C164.282 614.994 163.863 614.479 163.489 613.936L150.5 595.062H188.196Z",
    fill: "url(#paint1_linear_1858_1051)",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 560C248 523.5 51.9998 210.002 41 1C293 0.994216 292.195 0.999488 304 0.999488C309.554 0.999386 310.723 0.849059 313.5 1.49882C316.5 1.99882 319.392 3.19498 322 4.49882C324 5.49882 327 7.49882 329.5 9.99882C331.279 12.0315 333.5 14.4988 335 17.9988C335.5 18.4988 337 22.4988 337.589 25.7129C337.836 27.5447 338 28.4988 338 32.4995C338 32.4995 338 363.604 338 560Z",
    fill: "white",
    fillOpacity: 0.03
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1858_1051",
    x: -25,
    y: -25,
    width: 388,
    height: 668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1858_1051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1858_1051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1858_1051",
    x1: -31,
    y1: 550.558,
    x2: 224.106,
    y2: -45.5184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5468FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1858_1051",
    x1: -31,
    y1: 550.558,
    x2: 224.106,
    y2: -45.5184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5468FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B8BFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchTrianglePhone);
export default __webpack_public_path__ + "static/media/WatchTrianglePhone.f0387478f866a1bffe0d4196cf2f85b4.svg";
export { ForwardRef as ReactComponent };